import { OnboardingWizard } from './components/OnboardingWizard/OnboardingWizard.tsx';
import { OnboardingModuleProps } from './types.ts';

export function OnboardingModule({
  referralCode,
  mcKissockOffer,
  SubscriptionModule,
}: OnboardingModuleProps) {
  return (
    <OnboardingWizard
      referralCode={referralCode}
      mcKissockOffer={mcKissockOffer}
      SubscriptionModule={SubscriptionModule}
    />
  );
}
